import classNames from 'classnames';
import { ASSESSMENTS_COLOR_MAP } from '../../../../lib/colors';
import { colors } from '../../../../lib/colors';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CustomizedDot = (props: any) => {
  const {
    isSecondaryScore,
    isTertiaryScore,
    isActiveDot,
    cx,
    cy,
    payload,
    setShownAssessmentQandAIndex,
  } = props;

  const diameter = 12;
  const radius = diameter / 2;
  const outerDiameter = diameter * 2;

  const colorKey = isTertiaryScore
    ? payload.tertiaryColor
    : isSecondaryScore
    ? payload.secondaryColor
    : payload.primaryColor;

  const fillColor = ASSESSMENTS_COLOR_MAP?.[colorKey || 'neutral']?.defaultHex;

  if (isActiveDot)
    return (
      <svg
        x={cx - diameter}
        y={cy - diameter}
        width={outerDiameter}
        height={outerDiameter}
        className="cursor-pointer"
        viewBox={`0 0 ${outerDiameter} ${outerDiameter}`}
        onClick={() =>
          setShownAssessmentQandAIndex(payload.completedProgramAssessmentIndex)
        }
      >
        <circle
          opacity="0.2"
          cx={diameter}
          cy={diameter}
          r={diameter}
          fill={fillColor}
        />
        <circle
          opacity="0.5"
          cx={diameter}
          cy={diameter}
          r={radius * 1.5}
          fill={fillColor}
        />
        <circle cx={diameter} cy={diameter} r={radius} fill={fillColor} />
      </svg>
    );

  return (
    <svg
      x={cx - radius}
      y={cy - radius}
      width={diameter}
      height={diameter}
      viewBox={`0 0 ${diameter} ${diameter}`}
    >
      <rect width={diameter} height={diameter} rx={radius} fill={fillColor} />
    </svg>
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CustomTooltip = (props: any) => {
  const { payload } = props;

  if (payload && payload?.length) {
    const point = payload[0]?.payload;
    return (
      <div className="flex min-w-[2rem] flex-col items-center justify-center rounded-lg bg-white px-2 py-1 shadow-100">
        {point?.primaryScore != null && (
          <span className="text-small-caption text-green-125">
            {point.primaryScore}
          </span>
        )}
        {point?.secondaryScore != null && (
          <span className="text-small-caption text-green-125">
            {point.secondaryScore}
          </span>
        )}
        {point?.tertiaryScore != null && (
          <span className="text-small-caption text-green-125">
            {point.tertiaryScore}
          </span>
        )}
      </div>
    );
  }
  return null;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CustomAxisTick = ({ x, y, payload, isXAxis }: any) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        dy={isXAxis ? 20 : 3}
        dx={isXAxis ? -10 : -20}
        className={classNames(
          'text-small-label text-neutral-125',
          isXAxis && 'font-bold',
        )}
      >
        {payload.value}
      </text>
    </g>
  );
};

export const GraphLegend = ({
  items,
}: {
  items: Array<{ label: string; style: 'solid' | 'dashed' | 'dotted' }>;
}) => {
  return (
    <div className="flex flex-row flex-wrap items-center justify-center gap-x-4 gap-y-1 px-6 pb-1">
      {items.map((item) => (
        <div key={item.label} className="flex flex-row items-center gap-1.5">
          <svg width="20" height="8" viewBox="0 0 20 8" aria-hidden>
            <line
              x1="0"
              y1="4"
              x2="20"
              y2="4"
              stroke={colors.neutral[100]}
              strokeWidth="2"
              strokeDasharray={
                item.style === 'dashed'
                  ? '4 4'
                  : item.style === 'dotted'
                  ? '2 3'
                  : undefined
              }
            />
          </svg>
          <span className="text-small-caption text-neutral-125">
            {item.label}
          </span>
        </div>
      ))}
    </div>
  );
};
